import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    Badge,
    Text,
    Flex
} from '@chakra-ui/react'
import Card from '../../../Components/Card'
import { useGet } from 'hooks/useHttp'
import { OrderPaymentData } from '../../../../../pages/Sales/types'
import dayjs from 'dayjs'
import useStorage from '../../../../../hooks/useStorage'
import OrderPaymentModalView from './OrderPaymentModalView'
import Client from '../../../../../models/client'
import TypeIdentificationDocument, {
    TypeIdentificationDocumentByCode
} from '../../../../../utilities/type_identification_document'
import Actions from './ActionSales'
import Pagination from '../../../../../components/Pagination'
import { useState } from 'react'
import { storagePage } from '../../../storage'
import { useRender } from 'redity'
import { Keys } from '../../../constant'
import { getColorPayment } from '../../../../../utilities/colorPayment'

export default function SalesTable() {
    useRender(Keys.SALES_TABLE)
    const [page, setPage] = useState(1)
    const { openingDateId, openingDates } = storagePage
    const [limit, setLimit] = useState(10)
    const queries = new URLSearchParams()
    queries.set('page', page.toString())
    queries.set('limit', limit.toString())
    if (openingDateId) {
        queries.set('cashbox_user_ids', openingDateId.toString())
    } else {
        queries.set('cashbox_user_ids', openingDates.map(o => o.id).toString())
    }
    const { data } = useGet<OrderPaymentData[]>(
        `/api/v2/order_payments?${queries.toString()}`,
        []
    )

    const { cashboxes } = useStorage()

    function getUserCashbox(cashbox_id: number) {
        const cashbox = cashboxes.find(c => c.id === cashbox_id)
        return cashbox?.user
            ? `${cashbox.user.firstname} ${cashbox.user.lastname}`
            : cashbox?.name
    }
    function getFullNameClient(client: Client) {
        const fullNumber = `${
            TypeIdentificationDocument[client.type_identification_document_id]
        }: ${client.number}`
        if (client.type_identification_document_id === 2) {
            return {
                fullName: client.business_name,
                fullNumber
            }
        }
        return {
            fullName: `${client.firstname} ${client.lastname}`,
            fullNumber
        }
    }

    function getTip(_data: OrderPaymentData['orderPaymentDetails']) {
        const opd = _data.find(_opd => _opd.type_payment_id === 4)
        return opd ? `S/${opd.amount.toFixed(2)}` : '-'
    }

    return (
        <Card
            gridGap={1}
            direction="column"
            w={{ base: 'full', md: '100%', lg: '100%' }}
        >
            <Text as="b" mb="2" fontSize="xl" align="center" w="full">
                Ventas Realizadas
            </Text>
            <TableContainer>
                <Table size="sm" className="table-a-la-orden">
                    <Thead>
                        <Tr>
                            <Th
                                textTransform="capitalize"
                                fontSize="14px"
                                textAlign="center"
                            >
                                Fecha
                            </Th>
                            <Th
                                textTransform="capitalize"
                                fontSize="14px"
                                textAlign="center"
                            >
                                Usuario
                            </Th>
                            <Th
                                textTransform="capitalize"
                                fontSize="14px"
                                textAlign="center"
                            >
                                Comprobante
                            </Th>
                            <Th
                                textTransform="capitalize"
                                fontSize="14px"
                                textAlign="center"
                            >
                                Cliente
                            </Th>
                            <Th
                                textTransform="capitalize"
                                fontSize="14px"
                                textAlign="center"
                            >
                                Monto
                            </Th>
                            <Th
                                textTransform="capitalize"
                                fontSize="14px"
                                textAlign="center"
                            >
                                Formas de pago
                            </Th>
                            <Th
                                textTransform="capitalize"
                                fontSize="14px"
                                textAlign="center"
                            >
                                Propina
                            </Th>
                            <Th
                                textTransform="capitalize"
                                fontSize="14px"
                                textAlign="center"
                            >
                                Mozo
                            </Th>
                            <Th
                                textTransform="capitalize"
                                fontSize="14px"
                                textAlign="center"
                            >
                                Estado
                            </Th>
                            <Th
                                textTransform="capitalize"
                                fontSize="14px"
                                textAlign="center"
                            >
                                Acciones
                            </Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {data.result.map(orderPayment => (
                            <Tr key={orderPayment.id}>
                                <Td>
                                    <OrderPaymentModalView
                                        orderPaymentId={orderPayment.id}
                                    >
                                        {dayjs(orderPayment.created_at).format(
                                            'DD/MM/YYYY hh:mm a'
                                        )}
                                    </OrderPaymentModalView>
                                </Td>
                                <Td>
                                    {getUserCashbox(
                                        orderPayment.cashbox_user.cashbox_id
                                    )}
                                </Td>
                                <Td>
                                    {orderPayment.sunat_voucher
                                        ? orderPayment.sunat_voucher.code
                                        : orderPayment.code}
                                </Td>
                                <Td>
                                    <Text>
                                        {orderPayment.sunat_voucher
                                            ? orderPayment.sunat_voucher
                                                  .client_name
                                            : getFullNameClient(
                                                  orderPayment.client
                                              ).fullName}
                                    </Text>
                                    <Text whiteSpace="nowrap" fontSize="xs">
                                        {orderPayment.sunat_voucher
                                            ? `${
                                                  TypeIdentificationDocumentByCode[
                                                      parseInt(
                                                          orderPayment
                                                              .sunat_voucher
                                                              .client_type_document
                                                      )
                                                  ]
                                              }: ${
                                                  orderPayment.sunat_voucher
                                                      .client_number_document
                                              }`
                                            : getFullNameClient(
                                                  orderPayment.client
                                              ).fullNumber}
                                    </Text>
                                </Td>
                                <Td>
                                    {' '}
                                    S/ {orderPayment.total_final.toFixed(2)}
                                </Td>
                                <Td>
                                    <Flex gap={1} flexWrap="wrap">
                                        {orderPayment.orderPaymentDetails
                                            .filter(
                                                opd => opd.type_payment_id !== 4
                                            )
                                            .map(opd => {
                                                const name =
                                                    opd?.sub_payment_type_data
                                                        ?.name ||
                                                    opd.order_payment_detail
                                                        .name

                                                return (
                                                    <Badge
                                                        key={opd.id}
                                                        variant="subtle"
                                                        colorScheme={getColorPayment(
                                                            name
                                                        )}
                                                        textTransform="capitalize"
                                                    >
                                                        {name}: S/
                                                        {opd.amount.toFixed(2)}
                                                    </Badge>
                                                )
                                            })}
                                    </Flex>
                                </Td>
                                <Td>
                                    {getTip(orderPayment.orderPaymentDetails)}
                                </Td>
                                <Td>
                                    {
                                        orderPayment.account_order.order.user
                                            .firstname
                                    }{' '}
                                    {
                                        orderPayment.account_order.order.user
                                            .lastname
                                    }
                                </Td>
                                <Td>
                                    {orderPayment.account_order.status === 2 ? (
                                        <Badge bg="alo-blue" color="white">
                                            Vigente
                                        </Badge>
                                    ) : (
                                        <Badge bg="error" color="white">
                                            Anulado
                                        </Badge>
                                    )}
                                </Td>
                                <Td>
                                    <Actions orderPayment={orderPayment} />
                                </Td>
                            </Tr>
                        ))}
                        {data.result.length === 0 && (
                            <Tr>
                                <Td colSpan={10}>
                                    <Text textAlign="center" color="gray.700">
                                        No se encontraron resultados
                                    </Text>
                                </Td>
                            </Tr>
                        )}
                    </Tbody>
                </Table>
            </TableContainer>
            <Pagination
                limit={limit}
                page={data.pagination?.page || page}
                onPage={setPage}
                onLimit={setLimit}
                pages={data.pagination?.pages || 0}
            />
        </Card>
    )
}
